import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static targets = ["saved"]
  static values = { reload: Boolean }

  changed(event) {
    const input = event.target
    if (input.type !== "checkbox") return
    input.setAttribute("aria-checked", input.checked)
    if (input.dataset.group === "show") this.dirty = true
    input.form.requestSubmit()
  }

  saved(event) {
    if (!event.detail.success) return
    this.savedTarget.classList.remove("opacity-0")
    clearTimeout(this.savedTimer)
    this.savedTimer = setTimeout(() => this.savedTarget.classList.add("opacity-0"), 2000)
  }

  closed(event) {
    if (!this.dirty || !this.reloadValue) return
    if (event.type === "keydown" && event.key !== "Escape") return
    if (event.type === "click" && event.target !== this.element && !event.target.closest("[data-close]")) return
    Turbo.visit(window.location.href, { action: "replace" })
  }
}
